import TicketsComponent from './TicketsComponent';
export default TicketsComponent;